(function () {
  function initFaq(root) {
    if (!root || root.dataset.usipicFaqInit === '1') return;
    root.dataset.usipicFaqInit = '1';

    var nav = root.querySelector('[data-faq-nav]');
    var navCard = root.querySelector('[data-faq-nav-card]');
    var searchAside = root.querySelector('[data-faq-search-aside]');
    var list = root.querySelector('[data-faq-list]');
    var search = root.querySelector('[data-faq-search]');
    var clearBtn = root.querySelector('[data-faq-search-clear]');
    var labelEl = root.querySelector('[data-faq-category-label]');
    var panelPrefix = root.querySelector('.usipic-faq__panel-prefix');
    var countEl = root.querySelector('[data-faq-article-count]');
    var emptyEl = root.querySelector('[data-faq-empty]');
    var showingPrefix = root.dataset.showingPrefix || 'Showing';
    var articlesSuffix = root.dataset.articlesSuffix || 'Articles';
    var articleSingular = root.dataset.articleSingular || 'Article';
    var searchResultsLabel = root.dataset.searchResultsLabel || 'All matched query results';
    var autoOpenFirst = root.dataset.autoOpenFirst === 'true';

    if (!list) return;

    var items = Array.prototype.slice.call(list.querySelectorAll('[data-faq-item]'));
    var navBtns = nav ? Array.prototype.slice.call(nav.querySelectorAll('[data-faq-nav-item]')) : [];
    var activeCategory = root.dataset.defaultCategory || (navBtns[0] && navBtns[0].dataset.category) || '';
    var lastCategory = activeCategory;

    function toggleSearchUi(hasQuery) {
      if (navCard) navCard.hidden = !!hasQuery;
      if (searchAside) searchAside.hidden = !hasQuery;
      if (clearBtn) clearBtn.hidden = !hasQuery;
    }

    function setCategory(key) {
      activeCategory = key || '';
      var searchVal = search ? search.value.trim().toLowerCase() : '';
      var visible = 0;

      toggleSearchUi(!!searchVal);

      navBtns.forEach(function (btn) {
        var on = btn.dataset.category === activeCategory && !searchVal;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-current', on ? 'true' : 'false');
      });

      items.forEach(function (item) {
        var matchCat = !activeCategory || item.dataset.category === activeCategory;
        var text = (item.dataset.searchText || '').toLowerCase();
        var matchSearch = !searchVal || text.indexOf(searchVal) !== -1;
        var show = (searchVal ? matchSearch : matchCat) && matchSearch;
        item.hidden = !show;
        if (!show && item.open) item.removeAttribute('open');
        if (show) visible += 1;
      });

      if (labelEl) {
        var activeBtn = navBtns.find(function (b) { return b.dataset.category === activeCategory; });
        labelEl.textContent = searchVal
          ? searchResultsLabel
          : (activeBtn ? activeBtn.dataset.categoryTitle || activeCategory : activeCategory);
      }

      if (panelPrefix) panelPrefix.hidden = !!searchVal;

      if (countEl) {
        var suffix = visible === 1 ? articleSingular : articlesSuffix;
        countEl.textContent = visible + ' ' + suffix;
      }

      if (emptyEl) {
        emptyEl.hidden = visible > 0;
      }

      if (autoOpenFirst && visible > 0 && !searchVal) {
        var first = items.find(function (item) { return !item.hidden; });
        if (first) first.setAttribute('open', '');
      }
    }

    navBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (search) search.value = '';
        lastCategory = btn.dataset.category;
        setCategory(lastCategory);
      });
    });

    if (search) {
      search.addEventListener('input', function () {
        if (search.value.trim()) {
          setCategory('');
        } else {
          setCategory(lastCategory || (navBtns[0] && navBtns[0].dataset.category) || '');
        }
      });
    }

    if (clearBtn && search) {
      clearBtn.addEventListener('click', function () {
        search.value = '';
        search.focus();
        setCategory(lastCategory || (navBtns[0] && navBtns[0].dataset.category) || '');
      });
    }

    list.addEventListener('toggle', function (e) {
      var target = e.target;
      if (target.tagName !== 'DETAILS') return;
      target.classList.toggle('is-open', target.open);
    }, true);

    setCategory(activeCategory);
  }

  function boot() {
    document.querySelectorAll('[data-usipic-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector('[data-usipic-faq]');
    if (el) initFaq(el);
  });
})();
